module.exports = __webpack_public_path__ + "b54fc9f98bc01de7f6228788bb5679eb.png";